export default {
  title: "Order Details Form",
  type: "rh/components/content/order-details-form",
  isContainer: false,
  config: {
    emptyLabel: "Order Details Form",
    isEmpty: () => false
  }
};
